import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import { router } from './router';
import { armE2EWalletSeam } from './e2e-seam';
import '@cere/cere-design-system/tokens.css';
import './styles/design-tokens.css';
import './styles/typography.css';
import './styles/globals.css';

// Bootstrap is a function, not top-level statements, because the await above
// would otherwise be a top-level await: the dev server serves native ESM and
// accepts it, but `vite build` targets es2020/chrome87 and fails outright
// ("Top-level await is not available in the configured target environment").
// That made a VITE_E2E build impossible — which went unnoticed while this tier
// only ever ran against the dev server. Ordering is unchanged: the seam is
// installed before the first render, exactly as the awaited module was.
async function main(): Promise<void> {
  await armE2EWalletSeam();

  const container = document.getElementById('root');
  if (!container) throw new Error('Missing #root element');

  createRoot(container).render(
    <StrictMode>
      <RouterProvider router={router} />
    </StrictMode>,
  );
}

// Surfaced rather than swallowed: without the catch, the `Missing #root`
// throw above would be an unhandled rejection instead of a module-eval error.
void main().catch((err: unknown) => {
  console.error(err);
  throw err;
});
